import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "modal fade show",
  id: "kt_modal_meeting_info",
  "aria-modal": "true",
  role: "dialog",
  ref: "newTargetModalRef"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  key: 0,
  class: "d-flex justify-content-center"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "fw-bolder"
}
const _hoisted_9 = {
  class: "btn btn-icon btn-sm btn-active-icon-primary",
  id: "kt_modal_meeting_info_close",
  "data-bs-dismiss": "modal"
}
const _hoisted_10 = { class: "svg-icon svg-icon-1" }
const _hoisted_11 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_12 = {
  key: 0,
  class: "d-flex justify-content-center mt-15"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "row mb-7" }
const _hoisted_16 = { class: "col-lg-4 fw-bold text-muted" }
const _hoisted_17 = { class: "col-lg-8" }
const _hoisted_18 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_19 = { class: "row mb-7" }
const _hoisted_20 = { class: "col-lg-4 fw-bold text-muted" }
const _hoisted_21 = { class: "col-lg-8" }
const _hoisted_22 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_23 = { class: "row mb-7" }
const _hoisted_24 = { class: "col-lg-4 fw-bold text-muted" }
const _hoisted_25 = { class: "col-lg-8" }
const _hoisted_26 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_27 = {
  key: 0,
  class: "row mb-7"
}
const _hoisted_28 = { class: "col-lg-4 fw-bold text-muted" }
const _hoisted_29 = { class: "col-lg-8" }
const _hoisted_30 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_31 = { class: "row mb-7" }
const _hoisted_32 = { class: "col-lg-4 fw-bold text-muted" }
const _hoisted_33 = { class: "col-lg-8" }
const _hoisted_34 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_35 = { class: "row mb-7" }
const _hoisted_36 = { class: "col-lg-4 fw-bold text-muted" }
const _hoisted_37 = { class: "col-lg-8" }
const _hoisted_38 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_39 = {
  key: 1,
  class: "badge-light badge fs-8 fw-bolderms-1"
}
const _hoisted_40 = { class: "row mb-7" }
const _hoisted_41 = { class: "col-lg-4 fw-bold text-muted" }
const _hoisted_42 = { class: "col-lg-3 fw-bold text-muted mx-3" }
const _hoisted_43 = { class: "col-lg-5" }
const _hoisted_44 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_45 = {
  key: 0,
  class: "badge-light-danger badge fs-8 fw-bolderms-1"
}
const _hoisted_46 = {
  key: 1,
  class: "badge-light-success badge fs-8 fw-bolderms-1"
}
const _hoisted_47 = { class: "modal-footer flex-center" }
const _hoisted_48 = {
  "data-bs-dismiss": "modal",
  type: "reset",
  id: "kt_modal_meeting_info_cancel",
  class: "btn btn-light me-3"
}
const _hoisted_49 = { class: "indicator-label" }
const _hoisted_50 = { class: "indicator-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.pageLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
            : _createCommentVNode("", true),
          (!_ctx.pageLoading)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_8, _toDisplayString(_ctx.meeting.topic), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          (_ctx.pageLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
            : _createCommentVNode("", true),
          (!_ctx.pageLoading)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.t("meeting.topic")) + " :", 1),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.meeting.topic), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.t("meeting.date")) + " :", 1),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.moment(_ctx.meeting.date).format("DD/MM/YYYY, H:mm")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.t("meeting.duration")) + " :", 1),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.meeting.duration), 1)
                  ])
                ]),
                (_ctx.meeting.salle)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.t("timetable.cabinet")) + " :", 1),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.meeting.salle), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.t("course.levels")) + " :", 1),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("span", _hoisted_34, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.meeting.levels, (level) => {
                        return (_openBlock(), _createElementBlock("span", {
                          class: "badge-light badge fs-8 fw-bolderms-1",
                          key: level
                        }, _toDisplayString(_ctx.t("dashboard.year" + level)), 1))
                      }), 128))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.t("course.teachers")) + " :", 1),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("span", _hoisted_38, [
                      (_ctx.meeting.teachers && _ctx.meeting.teachers.length != 0)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.meeting.teachers, (teacher) => {
                            return (_openBlock(), _createElementBlock("span", {
                              class: "badge-light badge fs-8 fw-bolderms-1",
                              key: teacher._id
                            }, _toDisplayString(teacher.employee.firstName +
                        " " +
                        teacher.employee.lastName), 1))
                          }), 128))
                        : (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(_ctx.t("course.allTeachers")), 1))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.t("meeting.attendances")) + " :", 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attendance, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "row mb-3",
                      key: item._id
                    }, [
                      _createElementVNode("label", _hoisted_42, _toDisplayString(item.teacher.employee.firstName +
                    " " +
                    item.teacher.employee.lastName) + " :", 1),
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("span", _hoisted_44, [
                          (item.status == 'rejected')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString(_ctx.t("meeting.rejected")), 1))
                            : _createCommentVNode("", true),
                          (item.status == 'confirmed')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(_ctx.t("meeting.confirmed")), 1))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_47, [
          _createElementVNode("button", _hoisted_48, _toDisplayString(_ctx.t("student.close")), 1),
          (!_ctx.pageLoading)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-lg btn-success",
                type: "submit",
                id: "kt_modal_meeting_info_cancel",
                "data-bs-dismiss": "modal",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editMeeting()))
              }, [
                _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.t("course.edit")), 1)
              ]))
            : _createCommentVNode("", true),
          (!_ctx.pageLoading)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "btn btn-lg btn-danger",
                type: "submit",
                id: "kt_modal_meeting_info_cancel",
                "data-bs-dismiss": "modal",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.deleteMeeting()))
              }, [
                _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.t("course.delete")), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 512))
}